module.exports = __webpack_public_path__ + "img/icon1.0bd996f7.svg";